module.exports = __webpack_public_path__ + "img/PS1_installed.1363800e.png";